import { GridOptions } from "ag-grid-community";
import { themeAlpine, themeQuartz } from "ag-grid-community";

import { dataGridColorParams } from "../../../theme/data-grid-colors";
import { PresetType } from "../types/types";

export const presets: Record<PresetType, GridOptions> = {
  default: {
    theme: themeQuartz.withParams(dataGridColorParams),
    pagination: true,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
  },
  minimal: {
    theme: themeAlpine.withParams(dataGridColorParams),
    pagination: false,
    defaultColDef: {
      sortable: false,
      filter: false,
      resizable: false,
      flex: 1,
    },
  },
};

export const getPresetConfig = (presetName: PresetType): GridOptions =>
  presets[presetName] || presets.default;
